<template>
  <div class="allLeaguesBox" v-if="list.length">
    <div class="flex flex-align-center title">
      <i class="fanIcon icon-font icon-fan"></i>
      <div>{{ langConfig.leagues[langConfig.curLang]['ALL_LEAGUES'] }}</div>
      <div class="close" @click="$emit('close')"></div>
    </div>
    <div class="country-search">
      <input :placeholder="`${langConfig.leagues[langConfig.curLang]['FILTER']}`" @input="countrySearch" />
    </div>
    <ul class="league-warp">
      <li
        v-for="(item, _countryIndex) in list || []"
        :key="item.id"
        :class="[
          _countryIndex >= amount && !more ? 'hidden' : '',
          selected.includes(item.id) ? 'active' : '',
        ]"
        v-show="
          !searchKey
            ? true
            : item.name.toLowerCase().indexOf(searchKey.toLowerCase()) != -1
        "
      >
        <div class="country" @click="countryClick(item.id)">
          <img
            class="country-flag"
            :src="common.countryDataImgGet(item.id)"
            @error="common.imgError($event, 'country')"
          />
          {{ item.name }}
        </div>
        <div class="league-list" v-show="selected.includes(item.id)">
          <div
            class="league-item"
            v-for="(_league, _leagueIndex) in item.league"
            :key="_league.id"
            @click="leagueChange(_countryIndex, _leagueIndex)"
          >
            <span :title="_league.shortName || _league.fullName">{{
              _league.shortName || _league.fullName
            }}</span>
          </div>
        </div>
      </li>
    </ul>
    <div
      class="more flex flex-align-center flex-pack-center"
      v-if="list.length > amount && !more && !searchKey ? true : false"
      @click="more = true"
    >
      <span>{{ langConfig.leagues[langConfig.curLang]['MORE'] }}</span>
      <i class="icon-font icon-arr"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: "allLeagues",
  props: ["list"],
  data() {
    return {
      searchKey: "",
      amount: 50, // 默认显示多少条
      more: false, // 隐藏更多
      selected: [],
    };
  },
  methods: {
    countryClick(id) {
      const selected = [...this.selected];
      if (selected.includes(id)) {
        this.selected = selected.filter((_id) => _id != id);
      } else {
        selected.push(id);
        this.selected = selected;
      }
    },
    leagueChange(countryIndex, leagueIndex) {
      document.documentElement.scrollTop = 0;
      this.$emit(
        "leagueChange",
        this.list[countryIndex],
        this.list[countryIndex]["league"][leagueIndex]
      );
    },
    countrySearch(e) {
      const key = e.target.value;
      this.searchKey = key;
      this.selected = [];
      if (key) this.more = true;
      else this.more = false;
    },
  },
};
</script>
<style lang="less" scoped>
.allLeaguesBox {
  padding: 16px 0;
  width: 168px;

  .title {
    font-family: @font_family_SF_Pro_Display;
    font-weight: bold;
    padding-bottom: 16px;

    .fanIcon {
      font-size: 22px;
      color: @color_8C8C8C;
      margin-right: 8px;
    }
  }
  .close {
    display: none;
  }

  .country-search {
    width: 160px;
    padding: 6px 0px 6px 8px;
    margin-bottom: 8px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    background-color: #fff;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 6px;
      left: 8px;
      width: 20px;
      height: 20px;
      background: url("../../../assets/images/icon-search.png") 0 0 / contain
        no-repeat;
    }

    input {
      border: 0;
      background-color: transparent;
      width: 100%;
      height: 20px;
      line-height: 20px;
      padding-left: 28px;
    }
  }

  .league-warp {
    padding-top: 8px;

    li {
      margin: 0 8px;
      cursor: pointer;
      color: @color_434343;
      font-size: 14px;
      font-family: @font_family_SF_Pro_Display;
      position: relative;

      &:hover {
        .country {
          background-color: #d9d9d9;

          &::after {
            content: "";
            width: 16px;
            height: 16px;
            background: url("../../../assets/images/icon-down.png") 0 0 /
              contain no-repeat;
            position: absolute;
            right: 8px;
            top: 8px;
          }
        }
      }

      &.active {
        .country {
          background-color: #d9d9d9;

          &::after {
            content: "";
            width: 16px;
            height: 16px;
            background: url("../../../assets/images/icon-up.png") 0 0 / contain
              no-repeat;
            position: absolute;
            right: 8px;
            top: 8px;
          }
        }
      }

      &.hidden {
        display: none;
      }

      .country {
        width: 100%;
        padding: 8px 32px 8px 0;
        border-radius: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        .country-flag {
          width: 18px;
          margin: 0 8px;
          height: 12px;
        }
      }

      .league-list {
        margin: 8px auto;

        .league-item {
          padding: 8px;
          border-radius: 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:hover {
            background-color: #d9d9d9;
          }
        }
      }
    }
  }

  .more {
    color: @color_434343;
    font-family: @font_family_SF_Pro_Display;
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid @color_BFBFBF;
    width: 152px;
    height: 24px;
    margin-top: 16px;
    cursor: pointer;

    i {
      color: @color_434343;
      font-size: 14px;
      margin-left: 4px;
      transform: rotate(-180deg);
    }
  }
}

@media screen and (max-width: 767px) {
  .allLeaguesBox {
    width: 100%;
    padding: 0 0.24rem 0.24rem;

    .title {
      font-size: 0.18rem;
      padding: 0.24rem 0 0.16rem;
      position: sticky;
      top: 0;
      z-index: 1;
      background-color: #fff;

      .fanIcon {
        display: none;
      }
    }

    .close {
      display: block;
      position: absolute;
      right: -0.03rem;
      top: 0.24rem;
      width: 0.2rem;
      height: 0.2rem;
      background: url("../../../assets/images/icon-close.png") 0 0 / contain
        no-repeat;
    }

    .country-search {
      position: sticky;
      top: 0.61rem;
      z-index: 1;
      width: 100%;
      padding: 0;
      padding-left: 0.44rem;
      margin-bottom: 0.12rem;
      border-radius: 1rem;
      border: 0;
      background-color: #f5f5f5;

      &::before {
        content: "";
        position: absolute;
        top: 0.08rem;
        left: 0.16rem;
        width: 0.2rem;
        height: 0.2rem;
      }

      input {
        display: block;
        height: 0.36rem;
        line-height: 0.36rem;
        padding-left: 0;
        font-size: 0.14rem;
      }
    }

    .league-warp {
      position: relative;
      padding-top: 0;
      li {
        margin: 0 0.08rem;
        font-size: 0.16rem;
        font-family: @font_family_SF_Pro_Display;
        &:hover {
          .country {
            background-color: transparent;
            &::after {
              width: 0.16rem;
              height: 0.16rem;
              right: 0.12rem;
              top: 0.1rem;
            }
          }
        }
        &.active {
          .country {
            background-color: #f5f5f5;

            &::after {
              content: "";
              width: 0.16rem;
              height: 0.16rem;
              right: 0.12rem;
              top: 0.1rem;
            }
          }
        }

        &.hidden {
          display: none;
        }

        .country {
          width: 100%;
          padding: 0.1rem 0.32rem 0.1rem 0.12rem;
          font-size: 0.16rem;

          &::after {
            position: absolute;
            content: "";
            width: 0.16rem;
            height: 0.16rem;
            right: 0.12rem;
            top: 0.1rem;
            background: url("../../../assets/images/icon-down.png") 0 0 /
              contain no-repeat;
          }

          .country-flag {
            width: 0.18rem;
            margin: 0 0.12rem;
            height: 0.12rem;
          }
        }

        .league-list {
          margin: 0 auto;
          padding: 0.06rem 0;

          .league-item {
            padding: 0.06rem 0.12rem;
            border-radius: 0.04rem;
            font-size: 0.14rem;

            &:hover {
              background-color: transparent;
              color: @color_FF6915;
            }
          }
        }
      }
    }

    .more {
      font-size: 0.14rem;
      border-radius: 0.04rem;
      width: 100%;
      height: 0.24rem;
      margin-top: 0.16rem;

      i {
        font-size: 0.14rem;
        margin-left: 0.04rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/views/leagues/components/allLeagues.vue